import React from 'react';
import Link from 'next/link';

import { HrefOption } from 'constants/type';

interface IProps {
  options: Array<HrefOption>;
  selected: string;
}

const SubHeader: React.FC<IProps> = ({ options, selected }: IProps) => {
  return (
    <nav className="depth-menu">
      <ul>
        {options.map((option, index) => {
          if (option.name === selected) {
            return (
              <li className="selected" key={index}>
                <Link href={option.href}>
                  <a>{option.name}</a>
                </Link>
              </li>
            );
          }
          return (
            <li key={index}>
              {option.name === '멤버 가이드' ? (
                <a target="_blank" rel="noopener noreferrer" href={option.href}>
                  {option.name}
                </a>
              ) : (
                <Link href={option.href}>
                  <a>{option.name}</a>
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default SubHeader;
